import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import UserImg from '../../assets/images/user.png';
import GenderImg from '../../assets/images/gender.png';
import FiPhoneImg from '../../assets/images/fi_phone.png';
import EmailImg from '../../assets/images/email.png';
import axiosInstance from '../../api/axiosInstance';
import BackArrow from '../../assets/images/Frame_18177.png';
import DoctorsOfficeDeskOneImg from '../../assets/images/doctors_office_1.png';
import LabDeskOneImg from '../../assets/images/lab_1.png';
import BillDeskOneImg from '../../assets/images/bill_1.png';
import RadiologyImg from '../../assets/images/lab_1.png'; // Using same icon as lab for now
import ConsultantImg from '../../assets/images/doctors_office_1.png'; // Using doctor icon for consultant
import InactivityTimer from '../../components/InactivityTimer';

const Dashboard = () => {
    const navigate = useNavigate();
    const [patientData, setPatientData] = useState({});

    // Function to calculate age from DOB
    const calculateAge = (dob) => {
        if (!dob) return { years: 0, months: 0, days: 0 };

        try {
            const dobDate = new Date(dob);

            const today = new Date();

            // Validate DOB
            if (isNaN(dobDate.getTime()) || dobDate > today) {
                return { years: 0, months: 0, days: 0 };
            }

            let years = today.getFullYear() - dobDate.getFullYear();
            let months = today.getMonth() - dobDate.getMonth();
            let days = today.getDate() - dobDate.getDate();

            // Adjust for negative days
            if (days < 0) {
                months -= 1;
                const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                days += lastMonth.getDate();
            }

            // Adjust for negative months
            if (months < 0) {
                years -= 1;
                months += 12;
            }

            // Ensure years is not negative
            if (years < 0) {
                return { years: 0, months: 0, days: 0 };
            }

            return { years, months, days };
        } catch (error) {
            console.error('Error calculating age:', error);
            return { years: 0, months: 0, days: 0 };
        }
    };

    const fetchPatientData = async () => {
        try {
            const response = await axiosInstance.get(`api/patient/details`);
            const rawData = response.data.patient || {};

            // Map API response to expected format
            const data = {
                patientName: `${rawData.prefix || ''} ${rawData.firstName || ''} ${rawData.middleName || ''} ${rawData.lastName || ''}`.replace(/\s+/g, ' ').trim(),
                mrno: rawData.mrno || 'N/A',
                gender: rawData.genderCode === 'M' ? 'Male' : rawData.genderCode === 'F' ? 'Female' : 'Other',
                dob: rawData.dob || null,
                age: rawData.age || null,
                createdAt: rawData.createdAt || null,
                patientType: rawData.externalPatientId ? 'HIMS Registered' : 'Local',
                aadharNumber: rawData.aadharNumber || 'N/A',
                mobileNo: rawData.contactNumber || 'N/A',
                email: rawData.emailAddress || 'N/A',
                village: rawData.address || 'N/A',
                pin: rawData.pinCode || 'N/A',
                locality: rawData.locality || 'N/A',
                district: rawData.district || 'N/A',
                city: rawData.city || 'N/A',
                postOffice: rawData.postOffice || 'N/A',
                state: rawData.state || 'N/A',
                policeStation: rawData.policeStation || 'N/A',
                country: rawData.nationality || 'N/A',
                patientImg: rawData.base64String ? `data:image/jpeg;base64,${rawData.base64String}` : null,
            };

            // Calculate age if DOB exists
            if (data.dob) {
                const { years, months, days } = calculateAge(data.dob);
                data.years = years;
                data.months = months;
                data.days = days;
            }

            setPatientData(data);
        } catch (error) {
            console.error('Error while fetching patient data:', error);
            setPatientData({});
        }
    };

    useEffect(() => {
        fetchPatientData();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('kiosk_token');
        navigate("/", { replace: true });
    };

    return (
        <>
            <InactivityTimer />
            <div className='flex items-center'>
                <Link to="/" className="flex w-28 mt-6 ml-14 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200" style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}>
                    <img src={BackArrow} alt="Back" className="mr-2" style={{ height: '24px', width: '24px' }} />
                    Back
                </Link>
                <span className='mt-8 ml-4' style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}>
                    Dashboard
                </span>
            </div>

            {/* Horizontal Line */}
            <hr className="mt-6 ml-14 mr-14 border-t-1 border-gray-300" />

            <div className="page-container flex flex-col">
                <div className="form-container flex-grow overflow-auto">
                    <div className='ml-14 mt-6 mr-14'>
                        <div className='grid grid-cols-[150px_2fr_3fr] gap-6 bg-[#42424A] p-4 rounded-lg'>
                            <div>
                                {patientData.patientImg && (
                                    <img
                                        src={patientData.patientImg}
                                        alt='Patient'
                                        className='rounded-xl mb-6'
                                        style={{ height: '160px', width: '148px' }}
                                    />
                                )}
                                {!patientData.patientImg && (
                                    <img
                                        src={UserImg}
                                        alt='Patient'
                                        className='rounded-xl p-2 mb-6 bg-[d3d3d3]'
                                        style={{ height: '160px', width: '148px' }}
                                    />
                                )}
                            </div>
                            <div className='font-roboto border-r border-1 border-[#757582]'>
                                <div className='flex items-center space-x-4'>
                                    <span className='text-white text-[22px] font-semibold'>
                                        {patientData.patientName}
                                    </span>

                                    <span className='flex items-center p-1 bg-[#565661] text-white rounded-xl'>
                                        <img src={GenderImg} alt='Gender' className='mr-1 h-4 w-4' />
                                        {patientData.gender}
                                    </span>
                                </div>
                                {/* MRN Number */}
                                <div className='mt-1 mb-2'>
                                    <span className='text-white text-[14px]'>MRN: </span>
                                    <span className='text-white text-[16px] font-semibold'>{patientData.mrno}</span>
                                </div>
                                <div className='font-roboto'>
                                    <div className="grid grid-cols-[2fr_3fr] text-white text-[14px] gap-4 mt-2">
                                        <div>
                                            <h3>Age:</h3>
                                        </div>
                                        <div>
                                            {patientData.dob ? (
                                                <span>
                                                    {patientData.years > 0 && `${patientData.years} years `}
                                                    {patientData.months > 0 && `${patientData.months} months `}
                                                    {`${patientData.days || 0} days `}
                                                    {"(" + patientData.dob + ")"}
                                                </span>
                                            ) : (
                                                patientData.age && (
                                                    <span>
                                                        {patientData.age}
                                                    </span>
                                                )
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[2fr_3fr] text-white text-[14px] gap-4 mt-2">
                                        <div>
                                            <h3>Registered on:</h3>
                                        </div>
                                        <div>
                                            <span className='flex'>
                                                {patientData.createdAt && new Date(patientData.createdAt).toLocaleString('en-GB', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: false
                                                })}
                                                <span className='flex items-center ms-2 px-1 bg-[#0FA968] text-white rounded-xl text-[14px]'>{patientData.patientType}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[2fr_3fr] text-white text-[14px] gap-4 mt-2">
                                        <div>
                                            <h3>Aadhar Number:</h3>
                                        </div>
                                        <div>
                                            <span>{patientData.aadharNumber}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='font-roboto'>
                                    <div className="grid grid-cols-[16px_auto] text-white text-[14px] gap-2 mt-2">
                                        <div>
                                            <img src={FiPhoneImg} alt='Phone' />
                                        </div>
                                        <div>
                                            <span>{patientData.mobileNo}</span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[16px_auto] text-white text-[14px] gap-2 mt-2">
                                        <div>
                                            <img src={EmailImg} alt='Email' />
                                        </div>
                                        <div>
                                            <span>{patientData.email}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="font-roboto">
                                <h1 className='text-[16px] text-[#92929E] font-semibold'>ADDRESS DETAILS</h1>
                                <div className="mt-2 grid grid-cols-2 text-white text-[14px] gap-4 mb-2">
                                    <div>
                                        <div className='grid grid-cols-[100px_300px]'>
                                            <div>
                                                <h3 className='text-[14px]'>Address:</h3>
                                            </div>
                                            <div>
                                                <span className='text-[14px]'>{patientData.village}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='grid grid-cols-2'>
                                            <div>
                                                <h3>Pin Code:</h3>
                                            </div>
                                            <div>
                                                <span>{patientData.pin}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 text-white text-[14px] gap-4 mb-2">
                                    <div>
                                        <div className='grid grid-cols-[100px_300px]'>
                                            <div>
                                                <h3 className='text-[14px]'>Locality:</h3>
                                            </div>
                                            <div>
                                                <span className='text-[14px]'>{patientData.locality}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='grid grid-cols-2'>
                                            <div>
                                                <h3>City:</h3>
                                            </div>
                                            <div>
                                                <span>{patientData.city}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 text-white text-[14px] gap-4 mb-2">
                                    <div>
                                        <div className='grid grid-cols-[100px_300px]'>
                                            <div>
                                                <h3 className='text-[14px]'>Post Office:</h3>
                                            </div>
                                            <div>
                                                <span className='text-[14px]'>{patientData.postOffice}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='grid grid-cols-2'>
                                            <div>
                                                <h3>District:</h3>
                                            </div>
                                            <div>
                                                <span>{patientData.district}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 text-white text-[14px] gap-4 mb-2">
                                    <div>
                                        <div className='grid grid-cols-[100px_300px]'>
                                            <div>
                                                <h3 className='text-[14px]'>Police Station:</h3>
                                            </div>
                                            <div>
                                                <span className='text-[14px]'>{patientData.policeStation}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='grid grid-cols-2'>
                                            <div>
                                                <h3>State:</h3>
                                            </div>
                                            <div>
                                                <span>{patientData.state}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 text-white text-[14px] gap-4 mb-2">
                                    <div>
                                        <div className='grid grid-cols-[100px_300px]'>
                                            <div>
                                                <h3 className='text-[14px]'></h3>
                                            </div>
                                            <div>
                                                <span className='text-[14px]'></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='grid grid-cols-2'>
                                            <div>
                                                <h3>Country:</h3>
                                            </div>
                                            <div>
                                                <span>{patientData.country}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='ml-14 mt-6 mr-14'>
                        <div className='grid grid-cols-4 gap-4'>
                            {/* <Link to="/book-appointment" className='bg-white p-4 rounded-lg flex flex-col items-center hover:shadow-lg transition-shadow duration-300'>
                                <img src={DoctorsOfficeDeskOneImg} className='h-[120px] w-[120px] mb-4' alt='doctors office desk one' />
                                <p className='font-roboto text-[24px] text-[#27272A] text-center' style={{ fontWeight: "500" }}>
                                    Book Appointment
                                </p>
                                <p className='font-roboto text-[18px] text-[#565661] text-center' style={{ fontWeight: "400" }}>
                                    Book new appointment with doctor
                                </p>
                            </Link>*/}
                            <Link to="#" className='bg-white p-4 rounded-lg flex flex-col items-center hover:shadow-lg transition-shadow duration-300'>
                                <img src={DoctorsOfficeDeskOneImg} className='h-[120px] w-[120px] mb-4' alt='doctors office desk one' />
                                <p className='font-roboto text-[24px] text-[#27272A] text-center' style={{ fontWeight: "500" }}>
                                    Book Appointment
                                </p>
                                <p className='font-roboto text-[18px] text-[#565661] text-center' style={{ fontWeight: "400" }}>
                                    Book new appointment with doctor
                                </p>
                            </Link>
                            {/* <Link to="/book-consultation" className='bg-white p-4 rounded-lg flex flex-col items-center hover:shadow-lg transition-shadow duration-300'>
                                <img src={ConsultantImg} className='h-[120px] w-[120px] mb-4' alt='consultant booking' />
                                <p className='font-roboto text-[24px] text-[#27272A] text-center' style={{ fontWeight: "500" }}>
                                    OPD Consultant Booking
                                </p>
                                <p className='font-roboto text-[18px] text-[#565661] text-center' style={{ fontWeight: "400" }}>
                                    Book OPD consultation with payment
                                </p>
                            </Link> */}
                            <Link to="/lab-reports" state={{ patientName: patientData.patientName }} className='bg-white p-4 rounded-lg flex flex-col items-center hover:shadow-lg transition-shadow duration-300'>
                                <img src={LabDeskOneImg} className='h-[120px] w-[120px] mb-4' alt='lab desk one' />
                                <p className='font-roboto text-[24px] text-[#27272A] text-center' style={{ fontWeight: "500" }}>
                                    Lab Reports
                                </p>
                                <p className='font-roboto text-[18px] text-[#565661] text-center' style={{ fontWeight: "400" }}>
                                    Get your lab test report
                                </p>
                            </Link>
                            <Link to="/radiology-reports" state={{ patientName: patientData.patientName }} className='bg-white p-4 rounded-lg flex flex-col items-center hover:shadow-lg transition-shadow duration-300'>
                                <img src={RadiologyImg} className='h-[120px] w-[120px] mb-4' alt='radiology' />
                                <p className='font-roboto text-[24px] text-[#27272A] text-center' style={{ fontWeight: "500" }}>
                                    Radiology Reports
                                </p>
                                <p className='font-roboto text-[18px] text-[#565661] text-center' style={{ fontWeight: "400" }}>
                                    Get your radiology test report
                                </p>
                            </Link>
                            <Link to="/billing" state={{ patientName: patientData.patientName }} className='bg-white p-4 rounded-lg flex flex-col items-center hover:shadow-lg transition-shadow duration-300'>
                                <img src={BillDeskOneImg} className='h-[120px] w-[120px] mb-4' alt='bill desk one' />
                                <p className='font-roboto text-[24px] text-[#27272A] text-center' style={{ fontWeight: "500" }}>
                                    Billing
                                </p>
                                <p className='font-roboto text-[18px] text-[#565661] text-center' style={{ fontWeight: "400" }}>
                                    Pay your Bills & generate invoice
                                </p>
                            </Link>
                        </div>

                        {/* Close Session Button */}
                        <div className='flex justify-center mt-6'>
                            <button
                                onClick={handleLogout}
                                className='px-6 py-3 text-white bg-red-600 hover:bg-red-700 rounded-lg font-semibold text-[18px] shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2'
                                style={{ fontFamily: 'Roboto' }}
                            >
                                <svg
                                    className="w-5 h-5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                    />
                                </svg>
                                Close Session
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;